// replace dangerous starting characters and remove seperators from the cell-value
// see: https://owasp.org/www-community/attacks/CSV_Injection
import NullOrUndefinedHelper from "@/utilities/system/helpers/NullOrUndefinedHelper";

export const sanatizeCsv = (stringToSanitize:string|undefined, isPhonenumber:boolean = false):string => {
    // also recheck type since runtime JS is typedynamic... :(
    if(NullOrUndefinedHelper(stringToSanitize) || typeof(stringToSanitize) !== "string") return stringToSanitize ?? "";

    let result = "";
    result = stringToSanitize.replace(/^[=+\-@\n\r\t]+/g, "").replace(/[;,]/gm, "").replace(/['"]/gm, "");
    return `${isPhonenumber ? "+" : ""}${result}`;
}